import Cookie from 'js-cookie';
export default function getLangData() {
  if (Cookie.get('lang') === 'en') {
    return require('../i18n/lang/english.json');
  } else {
   return require('../i18n/lang/arabic.json');
  }
}
